import { useTranslation } from 'react-i18next';

import { Wrapper, Paragraph } from '../../../../shared/ModalComponents';
import { StyledTitle, ButtonGroup } from './StyledComponents';
import { Button } from '../../../../shared/FormStyles/Button';

const DeleteFollowUp = ({ onCancel, onConfirm }) => {
  const { t } = useTranslation('send');

  return (
    <Wrapper>
      <StyledTitle>{t('followUp.confirmDeletionTitle')}</StyledTitle>
      <Paragraph>{t('followUp.confirmDeletionText')}</Paragraph>
      <ButtonGroup>
        <Button variant="tertiary" onClick={onCancel}>
          {t('followUp.noButton')}
        </Button>
        <Button variant="containedRed" ml="8px" onClick={onConfirm}>
          {t('followUp.yesButton')}
        </Button>
      </ButtonGroup>
    </Wrapper>
  );
};

export default DeleteFollowUp;
